import  {FC} from "react";
import {ItemManager} from "../../components";


export const ItemsPage: FC = () => {
  //#region html
    return <ItemManager/>;
  //#endregion
};
